// src/services/claim.service.ts
import api from '../config/api';
import {
  FETCH_CLAIMS_LOADING,
  FETCH_CLAIMS_SUCCESS,
  FETCH_CLAIMS_FAILURE,
  UPDATE_CLAIM_LOADING,
  UPDATE_CLAIM_SUCCESS,
  UPDATE_CLAIM_FAILURE
} from '../Types/claimTypes';

const BASE_URL = process.env.REACT_APP_API_URL;

export const fetchClaims = (type = '') => {
  return async dispatch => {
    dispatch({ type: FETCH_CLAIMS_LOADING });

    try {
      let url = `${BASE_URL}Claim/getAdminClaims`;

      if (type === 'Combined') {
        url = `${BASE_URL}Claim/getAdminClaims?type=${encodeURIComponent(
          'remoteWork'
        )}&type=${encodeURIComponent('thirdPartySite')}`;
      } else if (type) {
        url = `${BASE_URL}Claim/getAdminClaims?type=${encodeURIComponent(type)}`;
      }

      const response = await api.get(url);
      const operations = response.data.data;

      dispatch({
        type: FETCH_CLAIMS_SUCCESS,
        payload: operations
      });
    } catch (error) {
      dispatch({
        type: FETCH_CLAIMS_FAILURE,
        payload: error.message
      });
    }
  };
};

export const updateClaim = (item, data, type) => {
  return async dispatch => {
    dispatch({ type: UPDATE_CLAIM_LOADING });

    try {
      await api.post(`${BASE_URL}Claim/UpdateClaimAdmin/${item._id}`, data);

      const updatedClaim = {
        ...item,
        status: data.status,
        CommentAdmin: data.CommentAdmin,
        CommentUser: data.CommentUser,
        id: item._id
      };

      dispatch({
        type: UPDATE_CLAIM_SUCCESS,
        payload: updatedClaim
      });
      dispatch(fetchClaims(type));
    } catch (error) {
      dispatch({
        type: UPDATE_CLAIM_FAILURE,
        payload: error.response?.data?.message || error.message
      });
    }
  };
};
